import React, { Component } from "react";
import "./contact.css";
import logo from "../../../assets/logo.png";
import indianCities from "indian-states-cities";
import axios from "axios";
import toaster from "toasted-notes";
import "toasted-notes/src/styles.css";
import Lottie from "lottie-react-web";
import loading from "../../../assets/loading.json";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      states: indianCities.allStates(),
      cities: [],
      state: "",
      city: "",
      name: "",
      email: "",
      number: "",
      pincode: "",
      loading: false,
    };
  }

  componentDidMount() {}

  handleChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (this.state.state.length > 0) {
          this.setState({
            cities: indianCities.citiesForState(this.state.state),
          });
        } else {
          this.setState({
            city: "",
          });
        }
      }
    );
  };

  handleSendEmail = async () => {
    this.setState({ loading: true });
    if (
      this.state.name.length > 0 &&
      this.state.email.length > 0 &&
      this.state.number.length > 0 &&
      this.state.city.length > 0 &&
      this.state.state.length > 0 &&
      this.state.pincode.length > 0
    ) {
      var data = {
        name: this.state.name,
        email: this.state.email,
        phone: this.state.number,
        city: this.state.city,
        state: this.state.state,
        pincode: this.state.pincode,
      };
      var res = await axios.post("/api/sendContactDetails/", data);
      if (res.data === "Success") {
        toaster.notify(
          "We have recieved your details and will contact you soon..."
        );
        this.setState({ loading: false });
        this.props.close();
      } else {
        toaster.notify(
          "There's some error, Please try again later or call us !"
        );
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
      toaster.notify("We can't contact you if there's any empty field left ! ");
    }
  };

  render() {
    return (
      <div className="contact-back">
        <div className="contact">
          <i className="fas fa-times" onClick={this.props.close}></i>
          <div className="contact-head">
            <div className="left">
              <img src={logo} alt="" />
            </div>
            <div className="right">
              <p>
                Email:{" "}
                <a href="mailto:contact@theorydev.com">contact@theorydev.com</a>
              </p>
              <p>Phone Number</p>
              <p>
                <a href="tel:9711585293">+91 9711585293</a>
              </p>
              <p>
                <a href="tel:8391076673">+91 8391076673</a>
              </p>
            </div>
          </div>

          <div className="contact-body">
            <TextField
              fullWidth
              label="Full Name"
              variant="outlined"
              name="name"
              value={this.state.name}
              onChange={this.handleChange}
              size="small"
              className="form-group"
            />
            <TextField
              fullWidth
              label="Email"
              type="email"
              variant="outlined"
              name="email"
              value={this.state.email}
              onChange={this.handleChange}
              size="small"
              className="form-group"
            />
            <TextField
              fullWidth
              label="Phone Number"
              type="number"
              variant="outlined"
              name="number"
              value={this.state.number}
              onChange={this.handleChange}
              size="small"
              className="form-group"
            />
            <div className="twoFields">
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                className="firstSelect"
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  State
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={this.state.state}
                  name="state"
                  onChange={this.handleChange}
                  label="State"
                >
                  {this.state.states.map((state) => {
                    return <MenuItem value={state}>{state}</MenuItem>;
                  })}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                fullWidth
                size="small"
                disabled={this.state.state.length === 0}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  City
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={this.state.city}
                  name="city"
                  onChange={this.handleChange}
                  label="City"
                >
                  {this.state.cities.map((city) => {
                    return <MenuItem value={city}>{city}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </div>
            <TextField
              fullWidth
              label="Pincode"
              variant="outlined"
              name="pincode"
              value={this.state.pincode}
              size="small"
              onChange={this.handleChange}
              className="form-group"
            />

            <div className="contact-footer">
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleSendEmail}
              >
                {this.state.loading ? (
                  <Lottie
                    options={{ animationData: loading }}
                    width={30}
                    height={30}
                  />
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
